import React from 'react'
import { useStyles } from './homestudentmain_style'
import { Hidden } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import CTADashboardAlt from 'components/CTADashboardAlt/CTADashboardAlt'
import HomeBanner from './components/HomeBanner/HomeBanner'
import JoinTheClubBanner from './components/JoinTheClubBanner/JoinTheClubBanner'
import CompanyShowcase from './components/CompanyShowcase/CompanyShowcase'
import HomeStudentArticles from './components/HomeStudentArticles/HomeStudentArticles'
import HomeStats from './components/HomeStats/HomeStats'
import HomepageCompanyLogos from 'components/HomepageCompanyLogos/HomepageCompanyLogos'
import HomeStudentStudyChoice from './components/HomeStudentStudyChoice/HomeStudentStudyChoice'
import HomeStudentSchools from './components/HomeStudentSchools/HomeStudentSchools'
import HomeStudentPromotions from './components/HomeStudentPromotions/HomeStudentPromotions'

const HomeStudentMainPage = (props) => {
    const { user } = props
    const classes = useStyles()

    return (
        <Box className={classes.homeStudentMain}>
            <HomeBanner />
            <JoinTheClubBanner />
            <Hidden mdDown>
                <Box className={classes.backgroundWhite}>
                    <Container maxWidth='lg' disableGutters className={classes.homeStatsContainer}>
                        <HomeStats />
                    </Container>
                </Box>
            </Hidden>
            <Container maxWidth='lg'>
                <CompanyShowcase/>
            </Container>
            <Box className={classes.marginBottomContainer}>
                <HomepageCompanyLogos showCTA/>
            </Box>
            <Box className={classes.marginBottomContainer}>
                <CTADashboardAlt user={user} />
            </Box>
            <Container maxWidth='lg' className={classes.marginBottomContainer}>
                <HomeStudentArticles/>
            </Container>
            <Box maxWidth='lg' className={classes.marginBottomContainer}>
                <HomeStudentPromotions/>
            </Box>
            <Container maxWidth='lg' className={classes.marginBottomContainer}>
                <HomeStudentSchools/>
            </Container>
            <Container maxWidth='lg' className={classes.marginBottomContainer}>
                <HomeStudentStudyChoice/>
            </Container>
        </Box>
    )
}
export default HomeStudentMainPage
